module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1037-fbcc13d2e9ab1cebb0fd25258af9786f.png";